import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { AncillaryServices } from './pages/AncillaryServices';
import { UtilizationReview } from './pages/UtilizationReview';
import { MedicalBillReview } from './pages/MedicalBillReview';
import { CaseManagement } from './pages/CaseManagement';
import { MedicalTriageNurse } from './pages/MedicalTriageNurse';
import { Privacy } from './pages/Privacy';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        setTimeout(() => el.scrollIntoView({
          behavior: 'smooth'
        }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3ml1397n9rmih">
      <ScrollToTop data-id="element-1" data-mp="3mkho1yp07c85" />
      <div className="min-h-screen bg-brand-paper" data-id="element-2" data-mp="3mjzpuwis6nxl">
        <Navbar data-id="element-3" data-mp="3rbra6pbcfxfa" />
        <main data-id="element-4" data-mp="3rdaquh0wwahl">
          <Routes data-id="element-5" data-mp="3rdkl4gszp3t3">
            <Route path="/" element={<Home data-id="element-7" data-mp="5yimri0b7dt" />} data-id="element-6" data-mp="3rd17vdeab3le" />
            <Route path="/about" element={<About data-id="element-9" data-mp="4n7u7q58zd7" />} data-id="element-8" data-mp="6htjo98ovic" />
            <Route path="/contact" element={<Contact data-id="element-11" data-mp="2zld1r8m3ndb0" />} data-id="element-10" data-mp="82jt1oitsae" />
            <Route path="/services/ancillary" element={<AncillaryServices data-id="element-13" data-mp="2zn66ujh2dpgw" />} data-id="element-12" data-mp="2zm4wyibsb90r" />
            <Route path="/services/utilization-review" element={<UtilizationReview data-id="element-15" data-mp="38lrpeemjd4ho" />} data-id="element-14" data-mp="33m5c656pjo8v" />
            <Route path="/services/bill-review" element={<MedicalBillReview data-id="element-17" data-mp="3dle4ktlxcut4" />} data-id="element-16" data-mp="38l06o4e1f18t" />
            <Route path="/services/case-management" element={<CaseManagement data-id="element-19" data-mp="nur8c681cizz" />} data-id="element-18" data-mp="3dm5vvs8ho6dl" />
            <Route path="/services/triage" element={<MedicalTriageNurse data-id="element-21" data-mp="stkn01z26g1q" />} data-id="element-20" data-mp="suncq6knacg2" />
            <Route path="/privacy" element={<Privacy data-id="element-23" data-mp="3686tkdjumw2" />} data-id="element-22" data-mp="swqd9kjfbnz1" />
          </Routes>
        </main>
        <Footer data-id="element-24" data-mp="34nbvtnbp1xo" />
      </div>
    </BrowserRouter>;
}